import { Injectable } from '@angular/core';
import { SyssaServicePkg } from './syssaPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SyssaService extends SyssaServicePkg {
  constructor() {
    super();
  }
}
